var map = {
	"./Cyviz.png": "6f2d",
	"./VC-微软团队室.png": "6d7d",
	"./VC-表面轮毂.png": "7735",
	"./VC系统.png": "4daf",
	"./互动桌.png": "a691",
	"./圆桌会议.png": "def7",
	"./扬声器电话.png": "a56e",
	"./投影仪.png": "36b5",
	"./无线内容分享.png": "c080",
	"./电话.png": "b077",
	"./白板.png": "75af",
	"./监视器.png": "73bf",
	"./相邻房间-可折叠墙.png": "f237",
	"./窗户.png": "c68e",
	"./高清数据线.png": "a0bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c8e";